



















import { Component, Vue } from 'vue-property-decorator'
import consultants from '@/data/consultants'
import Consultant from '@/components/Consultant.vue'

@Component({
  components: {
    Consultant
  }
})
export default class Consultants extends Vue {
  private readonly consultants = consultants
}
